import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import styles from './CloseChatRemarksModal.module.css';

const CloseChatRemarksModal = ({ show, onClose, onSubmit }) => {
    const { t } = useTranslation('common');
    const [remarks, setRemarks] = useState('');
    const [error, setError] = useState('');
    const textareaRef = useRef(null);

    useEffect(() => {
        if (show && textareaRef.current) {
            textareaRef.current.focus();
        }
    }, [show]);

    const handleConfirm = () => {
        const trimmed = remarks.trim();
        if (trimmed.length < 4 || trimmed.length > 128) {
            setError(t('Remarks must be between 4 and 128 characters'));
            return;
        }
        setError('');
        onSubmit(trimmed);
        setRemarks('');
    };

    const handleChange = (e) => {
        setRemarks(e.target.value);
        if (error) setError('');
    };

    return (
        <Modal show={show} onHide={onClose} dialogClassName={`modal-dialog ${styles['rtl-modal']}`} centered>
            <Modal.Header>
                <Modal.Title>{t('Closing Inquire Summary')}</Modal.Title>
            </Modal.Header>
            <Modal.Body className={styles['modal-body']}>
                <Form.Group controlId="closeRemarks">
                    <Form.Label>{t('Please provide remarks before closing')}</Form.Label>
                    <Form.Control as="textarea" rows={3} value={remarks} isInvalid={!!error} onChange={handleChange} maxLength={128} ref={textareaRef} className={styles['no-resize']} />
                    <div className={styles['feedback-row']}>
                        <div className={styles['error-remarks']}>{error}</div>
                        <small className={styles['counter-remarks']}>{remarks.length}/128</small>
                    </div>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" onClick={handleConfirm}>{t('confirm')}</Button>
                <Button variant="secondary" onClick={onClose}>{t('Cancel')}</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CloseChatRemarksModal;
